import { render } from "./How.vue?vue&type=template&id=07da1fd1&scoped=true"
import script from "./How.vue?vue&type=script&lang=js"
export * from "./How.vue?vue&type=script&lang=js"

import "./How.vue?vue&type=style&index=0&id=07da1fd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07da1fd1"]])

export default __exports__